/*
 * TerriSTORY®
 *
 © Copyright 2022 AURA-EE
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * A copy of the GNU Affero General Public License should be present along
 * with this program at the root of current repository. If not, see
 * http://www.gnu.org/licenses/.
 */

import React from "react";
import { Link } from "react-router-dom";
import configData from "../../settings_data.js";

/**
 * This component manages the display of the application footer
 */
class NationalFooter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      classFooter: "footer"
    };

    // Initial one shot timer for hiding footer
    this.footerTimerId = setInterval(() => {
      this.setState({
        classFooter: "footer footer-small"
      });
      clearInterval(this.footerTimerId);
    }, configData.timeHideFooter);
  }
  render() {
    var _this$props$parentApi, _this$props$parentApi2;
    // Mouse over on footer
    const handleMouseEnterOnFooter = e => {
      this.setState({
        classFooter: "footer"
      });
    };
    const handleMouseLeaveFooter = e => {
      this.setState({
        classFooter: "footer footer-small"
      });
    };
    let classFooter = this.state.classFooter;
    return /*#__PURE__*/React.createElement("div", {
      className: classFooter,
      onMouseEnter: handleMouseEnterOnFooter,
      onMouseLeave: handleMouseLeaveFooter
    }, /*#__PURE__*/React.createElement("ul", {
      className: "menu-h"
    }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
      to: "/national/a_propos"
    }, /*#__PURE__*/React.createElement("button", null, "\xC0 propos"))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
      to: "/national/modules"
    }, /*#__PURE__*/React.createElement("button", null, "L'outil"))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
      to: "/national/statistiques"
    }, /*#__PURE__*/React.createElement("button", null, "Statistiques"))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
      to: "/national/open_source"
    }, /*#__PURE__*/React.createElement("button", null, "Open-Source"))), ((_this$props$parentApi = this.props.parentApi.data) === null || _this$props$parentApi === void 0 ? void 0 : (_this$props$parentApi2 = _this$props$parentApi.settings) === null || _this$props$parentApi2 === void 0 ? void 0 : _this$props$parentApi2.enable_newsletter_national) && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
      to: "/national/newsletter"
    }, /*#__PURE__*/React.createElement("button", null, "Newsletter"))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
      to: "/national/contact"
    }, /*#__PURE__*/React.createElement("button", null, "Contact"))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
      to: "/national/mentions_legales_cgu"
    }, /*#__PURE__*/React.createElement("button", null, "Mentions l\xE9gales")))));
  }
}
export default NationalFooter;